document.addEventListener('turbolinks:load', () => {
  // Apply autofocus to all Select2 search inputs when dropdown opens.
  $(document)
    .off('select2:open.select2-autofocus')
    .on('select2:open.select2-autofocus', () => {
      setTimeout(() => {
        const activeSearchField = document.querySelector('.select2-container--open .select2-search__field');
        activeSearchField?.focus();
      }, 0);
    });

  const searchForm = document.querySelector("[data-ajaxId='jobTitleSelect']");
  if (!searchForm) return;

  $('.select2-container').remove();
  $(searchForm).select2({ tags: true });
});
